import React, { useRef } from "react";

/**
 * Magnetischer Button: zieht sich sanft in Richtung Cursor, solange die Maus in der Nähe ist,
 * und springt beim Verlassen weich zurück. Bewegung läuft komplett über ref/DOM (kein React-State),
 * damit es bei jeder Mausbewegung butterweich bleibt statt zu ruckeln.
 *
 * Nutzung: <MagneticButton onClick={...} className="btn-primary">Text</MagneticButton>
 * Rendert einen <button>, alle Props (className, onClick, ...) werden durchgereicht.
 */
export function MagneticButton({ children, strength = 0.35, className = "", style = {}, ...props }) {
  const ref = useRef(null);

  const onMouseMove = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };

  const onMouseLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = "translate(0, 0)";
  };

  return (
    <button
      ref={ref}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      className={className}
      style={{ transition: "transform 0.25s cubic-bezier(0.16,1,0.3,1)", display: "inline-flex", ...style }}
      {...props}
    >
      {children}
    </button>
  );
}
